// @flow

import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import { type UserInputValidationError, type UserInputValidatorArgs, onlyWhenSupport, VALID } from '@tectonics/prs/validation';
import { getSafeCheckoutPaymentOptions } from '@tectonics/prs/incoming-payment';
import { getEWalletCheckoutPaymentOptions } from '@tectonics/prs/incoming-payment/checkout-payment-options';
import { getAvailableMobileMoneyNetworks } from '@tectonics/prs/mobile-money/mobile-money-networks';
import { validateMobileMoneyNetwork } from '@tectonics/prs/mobile-money/validation/mobile-money-network';

export function validator({
  prsSupport,
  spec,
  userInputName,
  userInputValue,
  userInputValues,
  incomingPayment,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);

  if (userInputName === 'selectedEWallet') {
    return onlyWhen('field_ewallet_select_wallet') && validateEwallet(userInputValue);
  }

  if (userInputName === 'selectedMobileMoneyNetwork' && incomingPayment.status === 'OP') {
    const announcedEwallets = getEWalletCheckoutPaymentOptions(getSafeCheckoutPaymentOptions(incomingPayment));
    return validateMobileMoneyNetwork(userInputValue, getAvailableMobileMoneyNetworks(currentFeatures, announcedEwallets));
  }

  return VALID;
}

function validateEwallet(ewalletCode?: string): ?UserInputValidationError {
  if (!ewalletCode || ewalletCode.trim() === '')
    return { id: 'empty' };

  return VALID;
}
